import { create } from "domain";
import { useFetchData } from "../../../hooks/useFetch";
import { BaseResponse } from "../../../models/response/base-response";
import { ApiConfig, API_ACCOUNTING_ACCOUNTS_ROUTER } from "../../../services/api-config";

export interface AccountingAccount {
  id: number;
  parent_id?: number;
  path?: string;
  code: string;
  name: string;
  english_name?: string;
  type?: number; // Tùy backend định nghĩa
  nature?: number; // 1: Dư Nợ, 2: Dư Có, 3: Lưỡng tính (tham khảo)
  status: number; // 0: Inactive, 1: Active
  description?: string;
  debit?: number; // Số dư bên Nợ
  credit?: number; // Số dư bên Có
  created_at?: string;
  updated_at?: string;
}

export interface AccountingAccountListParams {
  page?: number;
  limit?: number;
  key_search?: string;
  status?: number; // 1: active, 0: inactive
  type?: number | null; // dùng cho filter giao diện (backend có thể bỏ qua)
}

export const AccountingAccountService = {
  list: () => {
    const { request, baseResponse, loading } = useFetchData.Get<AccountingAccount>({
      projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE,
    });
    return {
      fetch: (params: AccountingAccountListParams = {}) => {
        const finalParams = {
          page: 1,
          limit: 50,
          key_search: "",
          status: 1,
          type: null,
          ...params,
        };
        return request({ endPoint: API_ACCOUNTING_ACCOUNTS_ROUTER.API_ACCOUNTING_ACCOUNTS_LIST, data: finalParams });
      },
      response: baseResponse,
      loading,
    };
  },

  countTab: () => {
    const { request, baseResponse, loading } = useFetchData.Get<{ active: number; inactive: number }>({
      projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE,
    });
    return {
      fetch: (params: { key_search?: string; type?: number | null; parent_id?: number }) =>
        request({ endPoint: API_ACCOUNTING_ACCOUNTS_ROUTER.API_ACCOUNTING_ACCOUNTS_COUNT_TAB, data: params }),
      response: baseResponse,
      loading,
    };
  },

  create: () => {
    const { request, baseResponse, loading } = useFetchData.Post<BaseResponse<AccountingAccount>>({
      projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE,
    });
    return {
      fetch: (payload: Partial<AccountingAccount>) =>
        request({ endPoint: API_ACCOUNTING_ACCOUNTS_ROUTER.API_ACCOUNTING_ACCOUNTS_CREATE, data: payload }),
      response: baseResponse,
      loading,
    };
  },

  update: () => {
    const { request, baseResponse, loading } = useFetchData.Post<BaseResponse<AccountingAccount>>({
      projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE,
    });
    return {
      fetch: (id: number, payload: Partial<AccountingAccount>) =>
        request({ endPoint: API_ACCOUNTING_ACCOUNTS_ROUTER.API_ACCOUNTING_ACCOUNTS_UPDATE(id), data: payload }),
      response: baseResponse,
      loading,
    };
  },

  detail: () => {
    const { request, baseResponse, loading } = useFetchData.Get<AccountingAccount>({
      projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE,
    });
    return {
      fetch: (id: number) => request({ endPoint: API_ACCOUNTING_ACCOUNTS_ROUTER.API_ACCOUNTING_ACCOUNTS_DETAIL(id) }),
      response: baseResponse,
      loading,
    };
  },
};
